import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { authState, AuthState } from '../constants/initial-state';
import * as $ from 'jquery';

export default function userReducer(state = authState, action: IAction) {
    switch (action.type) {
        case types.USER_LOGGING_IN:
            return {
                error: null,
                state: AuthState.loading,
                user: null
            };
        case types.USER_LOGGED_IN:
            $.ajaxSetup({ headers: { 'x-access-token': action.data.token } });
            return {
                error: null,
                state: AuthState.loggedIn,
                user: action.data
            };
        case types.USER_LOGIN_FAILED:
            return {
                error: action.data,
                state: AuthState.guest,
                user: null
            };
        case types.USER_LOGGING_OUT:
            return Object.assign({}, state, { state: AuthState.loading });
        case types.USER_LOGGED_OUT:
            return {
                error: null,
                state: AuthState.guest,
                user: null
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.reducer.ts